import {
  isValidElement,
  type ForwardRefExoticComponent,
  type DetailedReactHTMLElement,
  type ComponentProps,
  type FC,
} from 'react'
import { has, isObject } from 'lodash-es'

export const isComponentOfKind = <C extends FC, P extends ComponentProps<C>>(
  element: unknown,
  component: C | ForwardRefExoticComponent<P>,
): element is DetailedReactHTMLElement<P, HTMLElement> => {
  if (!isValidElement(element)) {
    return false
  }

  if (isObject(element.type) && has(element.type, '__emotion_base') && element.type.__emotion_base === component) {
    return true
  }

  return element.type === component
}
